import styled from "styled-components";
import Layout from "../../../components/custom/Layout";
import MawbInput from "../../../components/custom/MawbInput";
import { Label } from "reactstrap";
import { useEffect, useState } from "react";
import ActionIcon from "../../../components/custom/ActionIcon";
import apiClient from "../../../apiClient";
import useUser from "../../../customHooks/useUser";
import { IFFM } from "../../../globals/interfaces";
import { formatMawb, getTsDate, notify } from "../../../utils";
import VirtualTable from "../../../components/custom/VirtualTable";
import { Button } from "reactstrap";
import useLoading from "../../../customHooks/useLoading";

export default function PerishableStorage() {

    const { user } = useUser();
    const { s_unit, s_email } = user;
    const { setLoading } = useLoading();
    const s_destination = s_unit.substring(1, 4);
    const [s_mawb, set_s_mawb] = useState('');
    const [awbs, setAwbs] = useState<Array<IFFM>>([]);
    const [modified, setModified] = useState(false);

    useEffect(() => {
        setAwbs([]);
        set_s_mawb('');
    }, [s_destination]);

    useEffect(() => {
        setAwbs([]);
    }, [s_mawb]);

    const searchAwb = async () => {
        try {
            const res = await apiClient.get(`/perishable-storage?s_mawb=${s_mawb}&s_destination=${s_destination}`);
            setAwbs(res.data);
            setModified(false);
            if (!res.data.length) {
                notify('No AWBs found', 'warn');
            }
        } catch (err) {
            alert(err);
        }
    }

    const modifyStorageDate = async () => {
        if (!awbs.length) return;

        setLoading(true);
        try {
            const { s_mawb, s_flight_id } = awbs[0];
            const res = await apiClient.put(`/perishable-storage`, {
                s_mawb, 
                s_flight_id, 
                s_destination,
                s_modified_by: s_email,
                t_modified: getTsDate()
            });
            setAwbs(res.data);
            notify('Storage start date updated');
            setModified(true);
        } catch (err) {
            alert(err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Layout>
            <div>
                <h1>Perishable Storage</h1>
                <FlexContainer>
                    <h6>Enter AWB</h6>
                    <MawbInput value={s_mawb} onChange={set_s_mawb} />
                    <ActionIcon type={'search'} onClick={searchAwb} />
                    {
                        awbs.length > 0 && (
                            <ActionIcon 
                                type={'update'}
                                text={'Modify Storage Date'}
                                onClick={modifyStorageDate}
                                disabled={modified}
                                confirm={true}
                                confirmMessage={'This will update the storage start date.'}
                            />
                        )
                    }
                </FlexContainer>
                {
                    awbs.length > 0 && (
                        <div>
                            <VirtualTable<IFFM>
                                data={awbs}
                                mapping={[{
                                    name: 'Flight',
                                    value: 's_flight_id'
                                }, {
                                    name: 'Arrival Date',
                                    value: 'd_arrival_date',
                                    date: true,
                                    utc: true
                                }, {
                                    name: 'First Free Day',
                                    value: 'd_storage_first_free',
                                    date: true,
                                    utc: true
                                }, {
                                    name: 'Second Free Day',
                                    value: 'd_storage_second_free',
                                    date: true,
                                    utc: true
                                }, {
                                    name: 'Storage Start Date',
                                    value: 'd_storage_start',
                                    date: true,
                                    utc: true
                                }, {
                                    name: 'Created',
                                    value: 't_created',
                                    date: true,
                                    utc: true
                                }, {
                                    name: 'Created by',
                                    value: 's_created_by',
                                    email: true
                                }, {
                                    name: 'Modified',
                                    value: 't_modified',
                                    date: true,
                                    utc: true
                                }, {
                                    name: 'Modified by',
                                    value: 's_modified_by',
                                    email: true
                                }]}
                                numRows={15}
                            />
                        </div>
                    )
                }
            </div>
        </Layout>
    );
}

const FlexContainer = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 10px;
`;